import { render, staticRenderFns } from "./admin-uptime.vue?vue&type=template&id=1b8a4258&scoped=true&"
import script from "./admin-uptime.vue?vue&type=script&lang=js&"
export * from "./admin-uptime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a4258",
  null
  
)

export default component.exports